import './index.styl';
import TradePlayerPoolListPlayer from "../../Fantasy/Trades/TradePlayerPoolListPlayer";
import template from './index.jst';
import tpl_form_stats from './tpl_form_stats.jst';
import tpl_value_predictor from './tpl_value_predictor_stats.jst';
import tpl_consistency from './tpl_consistency_stats.jst';
import tpl_opposition from './tpl_opposition_stats.jst';
import tpl_venues from './tpl_venues_stats.jst';
import tpl_coach_choice from './tpl_coach_choice_stats.jst';

const tpls = {
	base: template,
	form: tpl_form_stats,
	value_predictor: tpl_value_predictor,
	consistency: tpl_consistency,
	opposition: tpl_opposition,
	venues: tpl_venues,
	coach_choice: tpl_coach_choice,
};

export class StatsCentrePlayerPoolListPlayer extends TradePlayerPoolListPlayer {
	get template() {
		const tpl = tpls[this.model.get('tpl_type')];

		return tpl || template;
	}
}

export default StatsCentrePlayerPoolListPlayer;